package one.healthium.login.ui.silentLogin

import kotlinx.serialization.Serializable

@Serializable
sealed interface LoginToken {
    @Serializable
    data class MagicLink(val token: String) : LoginToken
    @Serializable
    data class WebUser(val token: String) : LoginToken
}
